import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
export function Objections() {
  const objections = [{
    question: '¿Es solo para Argentina?',
    answer: 'Sí, el contenido está adaptado 100% a la legislación laboral argentina (LCT, convenios, ART, etc.). Si trabajás en RRHH en Argentina, este kit es para vos.'
  }, {
    question: '¿Necesito conocimientos previos de RRHH?',
    answer: 'No. Está pensado justamente para quienes cayeron en RRHH sin formación específica. Todo está explicado paso a paso, con casos prácticos y lenguaje claro.'
  }, {
    question: '¿Puedo usarlo si trabajo en una empresa grande?',
    answer: 'El kit está optimizado para PYMES (hasta 50-100 empleados). Si trabajás en una empresa más grande, igual te va a servir, pero está pensado para contextos donde no hay equipo ni sistemas complejos.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Inmediatamente después de la compra, te llega un email con el acceso a todos los PDFs. Podés descargarlos y tenerlos para siempre.'
  }, {
    question: '¿Las plantillas son editables?',
    answer: 'Sí, todas las plantillas vienen en formato editable (Word/Excel) para que las adaptes a tu empresa.'
  }, {
    question: '¿Hay garantía?',
    answer: 'Sí. Si en los próximos 7 días sentís que el kit no te sirve, te devolvemos el 100% de tu dinero, sin preguntas.'
  }];
  return <section className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-119">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-120">
        Preguntas frecuentes
      </h2>

      <div className="space-y-4" data-id="element-121">
        {objections.map((item, index) => <div key={index} className="bg-white rounded-lg p-6 shadow-sm border border-gray-200" data-id="element-122">
            <div className="flex items-start gap-3 mb-3" data-id="element-123">
              <HelpCircleIcon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-1" data-id="element-124" />
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-125">
                {item.question}
              </h3>
            </div>
            <p className="text-gray-700 pl-9" data-id="element-126">{item.answer}</p>
          </div>)}
      </div>
    </section>;
}